export const EDITOR_GEOMETRY_SELECTED = 'EDITOR_GEOMETRY_SELECTED'
export const EDITOR_INTERACT_SETTED = 'EDITOR_INTERACT_SETTED'

export const EDITOR_TOOL_SETTED = 'EDITOR_TOOL_SETTED'



// WEBPACK FOOTER //
// ./src/store/editor/editor.constants.js